"use client";
import { useState, useEffect } from "react";
import { FaMagnifyingGlass } from "react-icons/fa6";
import StoriesPlaylist from "@/components/StoriesPlaylist";
import api from "@/lib/api";


export default function Navbar({
  categories,
  searchTerm,
  setSearchTerm,
  filter,
  setFilter,
  resetData,
  totalStories,

}) {
  const [lazySearch, setLazySearch] = useState(searchTerm);
  const [playlists, setPlaylists] = useState([]);
  const [activePlaylist, setActivePlaylist] = useState("all");


  async function fetchPlaylists() {
    try {
      const res = await api("/api/v1/playlists", { method: "GET" });
      if (res.status === "ok") {
        setPlaylists(res.playlists);
      }
    } catch (e) {
      console.log(e);
    }
  }

  useEffect(() => {
    fetchPlaylists();
  }, []);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setSearchTerm(lazySearch);

      // reset playlist to "all" when searching
      setActivePlaylist("all");
      setFilter("all");

      resetData();
    }, 1500);

    return () => clearTimeout(timeoutId);
  }, [lazySearch]);

  return (
    <div className="w-full">
      <div className="p-3 bg-c1 text-white mx-auto rounded-b-lg shadow-lg max-w-xl">
        <div className="text-sm text-center">
          قصه شب برای همه کودکان این سرزمین
        </div>
        <div className="text-xs text-center">
          (بنیاد نظریانی |{" "}
          <a href="https://nazariani.org" target="_blank">
            Nazariani.org
          </a>
          )
        </div>
        <div className="relative mt-3 flex items-center gap-2">
          <div className="relative flex-1">
            <div className="absolute inset-y-0 start-0 flex items-center ps-3.5 pointer-events-none text-white">
              <FaMagnifyingGlass />
            </div>

            <input
              value={lazySearch}
              onInput={(e) => setLazySearch(e.target.value)}
              type="text"
              className="text-white bg-c2 text-xs rounded-lg block w-full ps-10 p-2.5 shadow-lg"
              placeholder="جستجو"
            />
          </div>

          <div className="
            text-yellow-500 bg-c2 text-xs font-bold 
            px-3 py-2 rounded-lg shadow-lg
            flex-none
            whitespace-nowrap
          ">
            {totalStories} داستان
          </div>
        </div>
        <StoriesPlaylist
          playlists={playlists}
          activeId={activePlaylist}
          onSelect={(p) => {
            if (p === "all") {
              setActivePlaylist("all");
              setFilter("all");
            }
            else if (p === "popular") {
              setActivePlaylist("popular");
              setFilter("plays");
            }
            else if (p === "new") {
              setActivePlaylist("new");
              setFilter("new");
            }
            else {
              setActivePlaylist(p);
              setFilter(`playlist:${p}`);
            }

            resetData();
          }}
        />


      </div>
    </div>
  );
}
